import { render, staticRenderFns } from "./ExternasTab.vue?vue&type=template&id=93e449c8"
import script from "./ExternasTab.vue?vue&type=script&lang=js"
export * from "./ExternasTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports